// Add your custom JS here.

// Mobile Menu
const mobileMenu = document.getElementById('main-nav');
const mobileMenuControl = document.getElementById('mobile-menu-control');
mobileMenuControl.addEventListener('click', () => {
    let expanded = mobileMenuControl.getAttribute('aria-expanded');
    let targetHeight = mobileMenu.scrollHeight;

    if(expanded === 'false') {
        mobileMenu.classList.toggle('active');
        mobileMenuControl.setAttribute('aria-expanded', 'true');
        mobileMenuControl.classList.toggle('active');
        mobileMenu.style.height = `${targetHeight}px`;
    } else {
        mobileMenu.classList.toggle('active');
        mobileMenuControl.setAttribute('aria-expanded', 'false');
        mobileMenuControl.classList.toggle('active');
        mobileMenu.style.height = '0px';
    }
});


// Initialise Swiper for all sliders on the site
document.addEventListener('DOMContentLoaded', function() {
    if (typeof Swiper === 'undefined') return;

    let allSliders = document.querySelectorAll('[data-slider]');

    allSliders.forEach(sliderEl => {
        let infiniteSlider = sliderEl.getAttribute('data-slider-infinite') === 'true';
        let maxVisible = parseInt(sliderEl.getAttribute('data-slider-max-visible'), 10) || 3;
        let startingSlide = parseInt(sliderEl.getAttribute('data-slider-initial-slide'), 10) || 1;
        let totalSlides = parseInt(sliderEl.getAttribute('data-slider-total-slides'), 10) || 1;

        const calculateLoopedSlides = () => {
            const width = window.innerWidth;
            if (width >= 992) return Math.min(totalSlides, maxVisible * 2 + 1); // desktop
            if (width >= 576) return Math.min(totalSlides, 4); // tablets
            return Math.min(totalSlides, 3); // phones
        };

        let swiperOptions = {
            loop: infiniteSlider,
            spaceBetween: 30,
            slidesPerView: 3,
            slidesPerGroup: 1,
            loopedSlides: totalSlides,
            centeredSlides: false,
            initialSlide: startingSlide,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: sliderEl.querySelector('.swiper-pagination'),
                clickable: true
            },
            navigation: {
                nextEl: sliderEl.querySelector('.swiper-button-next'),
                prevEl: sliderEl.querySelector('.swiper-button-prev')
            },
            breakpoints: {
                // Mobile devices (max-width: 575px)
                0: {
                    slidesPerView: 1,
                    loopedSlides: calculateLoopedSlides(),
                },
                // Tablets (min-width: 576px and up)
                576: {
                    slidesPerView: 2,
                    loopedSlides: calculateLoopedSlides(),
                },
                // Desktops (min-width: 992px and up)
                992: {
                    slidesPerView: maxVisible,
                    loopedSlides: calculateLoopedSlides(),
                }
            }
        };

        let swiper = new Swiper(sliderEl, swiperOptions);
    })
});